import React from "react";

export const InterventionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none">
      <path
        d="M13.9999 25.9529C20.5274 25.9529 25.9529 20.5274 25.9529 13.9999C25.9529 7.46088 20.5154 2.04688 13.9879 2.04688C7.44936 2.04687 2.04736 7.46088 2.04736 13.9999C2.04736 20.5274 7.46086 25.9529 13.9999 25.9529ZM9.34736 19.9999C8.98436 19.9999 8.73836 19.7419 8.73836 19.3669C8.73836 19.2149 8.77336 19.0624 8.83186 18.9219L13.1679 7.84737C13.3554 7.39038 13.6249 7.16788 14.0114 7.16788C14.3749 7.16788 14.6564 7.39038 14.8199 7.84788L19.1679 18.9219C19.2264 19.0624 19.2729 19.2149 19.2729 19.3669C19.2729 19.7419 19.0274 19.9999 18.6524 19.9999C18.4764 19.9999 18.2889 19.9299 18.1719 19.8124L14.2809 15.9099C14.1759 15.8049 14.0934 15.7459 14.0114 15.7459C13.9179 15.7459 13.8239 15.8044 13.7184 15.9099L9.81636 19.8124C9.69019 19.9332 9.52207 20.0004 9.34736 19.9999Z"
        fill="white"
      />
    </svg>
  );
};
